import { reatomAsync, withDataAtom } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import { toastHandler } from "src/util";

import { ISendCaptchaDTO } from "../../components/AuthClientModal/AuthClientModal";
import { getPoizonClients } from "./getUserPoizonClients";

const POIZON_SUCCESS_CODE = 200;
const CAPTCHA_ERROR_TOAST = "getCaptchaPoizonClient";
const LOGIN_ERROR_TOAST = "loginPoizonClient";

export const createCaptchaPoizonClientStore = (clientId: string) => {
  const getCaptchaPoizonClient = reatomAsync(
    async (_ctx, { clientId, getCaptchaRequest }: ISendCaptchaDTO) => {
      const response = await API.poizonSiteApi.userControllerGetCaptcha(
        clientId,
        getCaptchaRequest,
      );

      if (response.data.code !== POIZON_SUCCESS_CODE) {
        toastHandler.error({
          name: CAPTCHA_ERROR_TOAST,
          title: "Не удалось отправить код",
          content:
            "Poizon не отправил SMS/Viber код. Проверьте номер телефона и попробуйте позже",
        });

        return null;
      }

      toastHandler.dismiss(CAPTCHA_ERROR_TOAST);

      return response;
    },
    `getCaptchaPoizonClient${clientId}`,
  ).pipe(withDataAtom(null), withIsLoadingAtom());

  const getCaptchaPoizonClientIsLoading = getCaptchaPoizonClient.isLoadingAtom;

  const loginPoizonClient = reatomAsync(
    async (
      _ctx,
      clientId: string,
      code: string,
      userName: string,
      countryCode: number,
    ) => {
      const { data }: { data: unknown } =
        await API.poizonSiteApi.userControllerLogin(clientId, {
          userName,
          code,
          countryCode,
          noToast: true,
          type: "code",
          password: "",
          authCode: "",
        });

      if (data !== true) {
        toastHandler.error({
          name: LOGIN_ERROR_TOAST,
          title: "Не удалось авторизовать аккаунт",
          content:
            "Poizon не принял вход: код неверный или номер ограничен в Poizon. Проверьте SMS/Viber код или закройте окно и введите другой номер",
        });

        return false;
      }

      toastHandler.dismiss(LOGIN_ERROR_TOAST);

      return true;
    },
    "loginPoizonClient",
  ).pipe(withDataAtom(null), withIsLoadingAtom());

  loginPoizonClient.onFulfill.onCall((ctx) => getPoizonClients(ctx));

  const loginPoizonClientIsLoading = loginPoizonClient.isLoadingAtom;

  return {
    getCaptchaPoizonClient,
    getCaptchaPoizonClientIsLoading,
    loginPoizonClient,
    loginPoizonClientIsLoading,
  };
};
